import http from '@/assets/common/http';
// --------------------------------------------------品类管理
// 获取LKD系统大类
export function getLKDFirstKindFun(data) {
  const params = {
    SERVICE_ID: '10200',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取LKD系统二类
export function getLKDSecondKindFun(data) {
  const params = {
    SERVICE_ID: '10201',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 添加新SKU
export function addNewSKUFun(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增
export function addCategory(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取数据
export function quueryCategory(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除
export function deleteFun(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改
export function updateFun(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除类别
export function delCatalogFun(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取一级、二级、三级大类
export function getClassFun(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------温区管理
// 新增
export function addWQFun(data) {
  const params = {
    SERVICE_ID: '10073',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除
export function deleteWQ(data) {
  const params = {
    SERVICE_ID: '10073',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改
export function updateWQ(data) {
  const params = {
    SERVICE_ID: '10073',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// 拉取
export function queryWQ(data) {
  const params = {
    SERVICE_ID: '10073',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------在用SKU
// 新增使用SKU
export function addUseSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询
export function queryUseSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取全部可设置购买产品
export function queryShopSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 13,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置购买产品
export function addShopSKUFun(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 启用
export function startUseSKU(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 30,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 禁用
export function stopUseSKU(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 29,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除在用SKU
export function delUseSKUFun(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 未匹配的SKU
export function noMatchSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改SKU
export function updateUseSku(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出sku
export function ExportSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入SKU
export function enterSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量新增SKU
export function BatchImportSku(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量删除SKU
export function BatchDelSku(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
/**
 * 设置常购产品（支持单个/批量）
 * 接口：SERVICE_ID 10050 / OTYPE 27；GYS_ID 由本函数自动注入，调用方无需传递
 * @param {Object} data 业务参数
 * @param {(number|string)[]} data.PRODUCT_CODES 产品编码数组（单个产品也必须传数组，且不可为空）
 * @param {number} data.IS_FREQUENT 常购标记：1 设为常购，0 取消常购
 * @returns {Promise<*>} 成功时 resolve 后端返回数据；失败时 reject 错误文本
 * @example
 * // 单个设为常购
 * setFrequentSku({ PRODUCT_CODES: [100123], IS_FREQUENT: 1 });
 * // 批量取消常购
 * setFrequentSku({ PRODUCT_CODES: [100123, 100124], IS_FREQUENT: 0 });
 */
export function setFrequentSku(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 27,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量导入常用SKU
export function ImportCommonSKU(data) {
  const params = {
    SERVICE_ID: '10050',
    OTYPE: 21,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/skuManage.js